import React from 'react';
import { Helmet } from 'react-helmet';
import { ERPPage, ERPPageHeader } from '../../components/ui/ERPLayout';
import WeeklyReportsPanel from '../loncheados-control-center/components/WeeklyReportsPanel';

const InformesLoncheado = () => (
  <>
    <Helmet>
      <title>Informes de Loncheado | Las Dos Doncellas</title>
    </Helmet>
    <ERPPage>
      <ERPPageHeader
        title="Informes de Loncheado"
        subtitle="Producción · Rendimiento · Trazabilidad"
      />
      <WeeklyReportsPanel />
    </ERPPage>
  </>
);

export default InformesLoncheado;
